import Cal, { getCalApi } from '@calcom/embed-react'
import React, { useEffect, useState } from 'react'
// import createBookingFromIntent from '../../../tbd_services/backend/createBookingFromIntent'
import { DateTime } from 'luxon'

const parseHttpDateTime = (datetimeStr) => {
    return DateTime.fromHTTP(datetimeStr);
}

const CalcomInline = ({ data, calConfig }) => {
  const [bookingFromIntentAttempts, setBookingFromIntentAttempts] = useState(new Map())
  const [bookingFromIntentResTracker, setBookingFromIntentResTracker] = useState(new Map())
  const [bookDetailWithSuccess, setBookDetailWithSuccess] = useState(null)
  const [bookingDto, setBookingDto] = useState(null)
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    if (!bookDetailWithSuccess) return
    bookingSuccessHandler(bookDetailWithSuccess).then(r => r)
  }, [bookDetailWithSuccess])

  const bookingSuccessHandler = async detail => {
    if (!detail) return
    const attempts = bookingFromIntentAttempts?.get(detail.tbdBookId) ?? 0
    const isSuccess = bookingFromIntentResTracker?.get(detail.tbdBookId) ?? false
    //already created
    if (attempts > 0 && isSuccess) {
      console.log('Success')
      return
    }
    // calConfig.toggleLoadingScreen(true)
    bookingFromIntentAttempts.set(detail.tbdBookId, attempts + 1)
    setBookingFromIntentAttempts(bookingFromIntentAttempts)
    ;(async function() {
    //   await createBookingFromIntent(detail).then(dto => {
    //     bookingFromIntentResTracker.set(detail.tbdBookId, true)
    //     setBookingFromIntentResTracker(bookingFromIntentResTracker)
    //     setBookingDto(dto)
    //   })
    })().then(r => r)
  }

  useEffect(() => {
    if (!bookingDto) return
    ;(async function() {
    })()
    //calConfig.toggleLoadingScreen(false);
  }, [bookingDto])

  const getUpdatedBookingDataWithSuccess = (calcomDetail, currBookingData) => {
    const {
      date,
      organizer: { timeZone },
    } = calcomDetail?.data
    const updated = {
      ...currBookingData,
      appntStart: parseHttpDateTime(calcomDetail?.data?.date).toISO(),
      calenderTimeZone: calcomDetail?.data?.organizer?.timeZone ?? '',
    }
    return updated
  }

  useEffect(() => {
    const styles = {
      back: false,
      width: '100%',
      height: '100%',
      overflow: 'scroll',
      overflowY: 'scroll',
      alignSelf: 'center',
      branding: { brandColor: '#FDFAF1' },
    }
    ;(async function() {
      const cal = await getCalApi()
      cal('preload', { calLink: calConfig?.link ?? 'krajs/30min' })
      cal('on', {
        action: 'bookingSuccessful',
        callback: e => {
          if (data && e?.detail) setBookDetailWithSuccess(getUpdatedBookingDataWithSuccess(e?.detail, data))
        },
      })
      cal('ui', styles)
    })()
  }, [])

  return (
    <div
      id="scroller-boss"
      style={{
        width: '100%',
        height: '100%',
        maxHeight: '70vh',
        overflow: 'scroll',
        alignSelf: 'center',
        background: 'white',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          width: '0',
          height: '0',
        },
      }}
    >
      <Cal
        calLink={'krajs/30min'}
        config={{
          name: `${data?.firstName ?? ''} ${data?.lastName ?? ''} `,
          email: `${data?.email ?? ''}`,
          'meta.tbdBookId': `${data?.id ?? ''}`,
          "meta['tbdBookId']": `${data?.id ?? ''}`,
          tbdBookId: `${data?.id ?? ''}`,
          theme: 'light',
        }}
        style={{ marginTop: 10 }}
      />
    </div>
  )
}

export default CalcomInline
